
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fossil-fuel-top",attrs:{"d":"M3.916 6.275c-1.054 1.58-.475 4.433 0 5.7H5.34c0-.475.19-1.52.95-1.9.95-.475 1.899.95 3.324.95.95 0 1.9-.633 2.376-.95.633.158 1.424.475 2.85.475 1.899 0 2.85-1.425 2.85-1.425s3.798 0 3.324-3.8c-.476-2.375-3.325-2.85-4.274-2.375 0 0-1.902-.95-3.801-.95-1.9 0-2.972.492-3.8.95-1.04.575-1.741 1.425-1.9 1.9-.316 0-2.374 0-3.324 1.425z","fill":"var(--color-fossil-fuel-icon-color-top)"}}),_c('path',{staticClass:"fossil-fuel-bottom",attrs:{"d":"M5.651 11.678a.2.2 0 00-.198-.178h-1.69a.2.2 0 00-.198.178l-.982 9.1a.2.2 0 00.2.222H15.59a.2.2 0 00.2-.2v-7.076a.2.2 0 00-.29-.18l-4.193 2.098a.2.2 0 01-.29-.18v-1.738a.2.2 0 00-.29-.18L6.36 15.733a.2.2 0 01-.289-.158l-.42-3.896z","fill":"var(--color-fossil-fuel-icon-color-bottom)"}})])
          )
        }
      }
    